import types from '../constants/actionTypes';

export function updateCollectiveResults(data) {
  return {
    type: types.collectives.NEW_COLLECTIVES_SUCCESS,
    payload: data,
  };
};

export function mergeRequestDialog(id) {
  return {
    type: types.collectives.MERGE_DIALOG_REQUEST,
    id: id,
  };
};

export function mergeCancelDialog(id) {
  return {
    type: types.collectives.MERGE_DIALOG_CANCEL,
    id: id,
  };
};

export function setMergeInto(id) {
  return {
    type: types.collectives.SET_MERGE_INTO,
    id: id,
  };
};

export function clearAllCollectives(id) {
  return {
    type: types.collectives.CLEAR_ALL,
  };
};

export function resetCollectiveReportButton() {
  return {
    type: types.collectives.RESET_REPORT_BUTTON,
  };
}

export function setCollectiveActive(id, isChecked) {
  return {
    type: types.collectives.SET_ACTIVE,
    id: id,
    value: isChecked,
  };
}



/** WEBPACK FOOTER **
 ** ./actions/collectives.js
 **/